var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"py-4 mt-4"},[_c('div',{staticClass:"container text-center"},[_c('small',[_vm._v("Copyright © Fiancar")])])])])}]

export { render, staticRenderFns }